import ApiClient from '@/services/apiClient/ApiClient'
import type { LandTagRelation } from '@popety-io/types'

const apiClient = new ApiClient()

// Get all tags (grouped by user)
export const getAllTags = async (): Promise<LandTagRelation[]> => {
  try {
    const response = await apiClient.get('/tags/land/all')
    if (response.errors) {
      throw new Error(response.errors[0].message)
    }
    return response.data as LandTagRelation[]
  } catch (error: any) {
    console.error('Failed to get all land tags:', error)
    throw new Error(error.message || 'Failed to fetch all land tags')
  }
}

// Get tags for a specific land
export const getTagsForLand = async (
  landId: string
): Promise<LandTagRelation[]> => {
  try {
    const response = await apiClient.get(`/tags/land/${landId}`)
    if (response.errors) {
      throw new Error(response.errors[0].message)
    }
    return response.data as LandTagRelation[]
  } catch (error: any) {
    console.error(`Failed to get tags for land ${landId}:`, error)
    throw new Error(error.message || 'Failed to fetch tags for land')
  }
}

// Add a new tag to a land
export const addTagToLand = async (
  landId: string,
  tagValue: string,
  color: string
): Promise<LandTagRelation> => {
  try {
    const response = await apiClient.post('/tags/land', {
      landId: parseInt(landId),
      tagValue: tagValue.trim(),
      color,
    })
    if (response.errors) {
      throw new Error(response.errors[0].message)
    }
    return response.data as LandTagRelation
  } catch (error: any) {
    console.error(`Failed to add tag to land ${landId}:`, error)
    throw new Error(error.message || 'Failed to add tag to land')
  }
}

// Remove a tag from a land
export const removeTagFromLand = async (
  landId: string,
  tagId: string
): Promise<void> => {
  try {
    const response = await apiClient.delete(`/tags/land/${landId}/${tagId}`)
    if (response.errors) {
      throw new Error(response.errors[0].message)
    }
  } catch (error: any) {
    console.error(`Failed to remove tag ${tagId} from land ${landId}:`, error)
    throw new Error(error.message || 'Failed to remove tag from land')
  }
}
